class LogFilter {
  constructor () {
    this.userId = null
    this.createdAt = [null, null]
  }
}

export default LogFilter
